import { Directory, Filesystem } from "@capacitor/filesystem";
import MultimediaMobileHelper from "./MultimediaMobileHelper";
import { Share } from "@capacitor/share";
import { files } from "jszip";
import { FileChunkReader } from "capacitor-file-chunk-reader";
export default class MultimediaHelper {
  static DropboxToken =
    "HqmkA9nKm0wAAAAAAADLWpj-stRJN_4JyfLxtRoZD-Rzpjyz9nnuI_CMbkRkOoSk";
  static FOLDER_MULTIMEDIA = "Multimedia";
  static FOLDER_RESULT = "Result";
  static FOLDER_NOTES = "Notes";
  static FOLDER_EXTRA_NOTES = "TextNote";
  static FOLDER_TASK = "Task";
  static FOLDER_GENERAL_TASK = "GeneralTask";
  static FOLDER_OTHER = "Other";

  static TYPE_IMAGE = 1;
  static TYPE_VIDEO = 2;
  static TYPE_YOUTUBE = 3;
  static TYPE_PDF = 4;

  constructor() {
    // queue elements to be uploaded
    this.uploadQueue = [];
    this.isUploading = false;
    this.urisToShare = [];
    this.dropbox = new window.Dropbox.Dropbox({
      accessToken: MultimediaHelper.DropboxToken,
    });
  }

  /**
   * Function to remove an element from the queue upload queue.
   *
   * @param name The name of the file to be removed
   * @param target_origin The location.href of the file to be removed.
   */

  removeElementFromUploadQueue(name, target_origin) {
    this.uploadQueue = this.uploadQueue.filter(
      (el) => el.fileName != name || el.request_origin != target_origin
    );
  }

  /**
   * Function called when Android/IOS wrappers finish uploading one photo from the upload queueu
   * @param file_name the name of the file finished uploading
   * @param target_request the location.href of the upload item
   * @param dbxPath the path_display of the uplaod element, used to reconstruct the element from database
   */
  onUploadDoneCallback(file_name, target_request, dbxPath) {
    let x = this.uploadQueue.find(
      (el) => el.fileName == file_name && el.request_origin == target_request
    );
    if (!x) return;
    let dbxItem = { path_display: dbxPath, name: file_name };
    dbxItem.type = MultimediaHelper.getTypeItem(dbxItem);

    this.dropbox
      .filesGetThumbnail({
        path: dbxItem.path_display,
        size: "w480h320",
      })
      .then((response) => {
        let url = window.URL.createObjectURL(response.fileBlob);
        dbxItem.thumbUrl = url;

        this.removeElementFromUploadQueue(file_name, target_request);
        this.finishCallback(target_request, file_name, dbxItem);
      })
      .catch((error) => {
        dbxItem.thumbUrl = "";

        this.removeElementFromUploadQueue(file_name, target_request);
        this.finishCallback(target_request, file_name, dbxItem);
      });
  }
  onUploadProgressCallback(file_name, percent, target_request) {
    let x = this.uploadQueue.find(
      (el) => el.fileName == file_name && el.request_origin == target_request
    );
    x.file.progress = percent;
    this.refreshUploadQueue();
  }

  /**
   * A function that adds elements
   * @description A callback function used by xamarin to add data to the uploadQueue.
   */

  async addDataToUploadQueue(fileName, imageUrl, isImage, target_origin) {
    const res = await fetch(imageUrl);
    const blob = await res.blob();
    this.uploadQueue.push({
      request_origin: target_origin,
      path: this.path,
      fileName: fileName,
      file: {
        actual_image: new File([blob], fileName, { type: "image/png" }),
        fileName: fileName,
        imageUrl: imageUrl,
        progress: 0,
        type:
          isImage == "True"
            ? MultimediaHelper.TYPE_IMAGE
            : MultimediaHelper.TYPE_VIDEO,
      },
    });
    this.refreshUploadQueue();
    // if (this.isUploading) return;
    // this.isUploading = true;
    // this.startUploadQueueElements();
  }
  /**
   * Setter for the current multimedia session.
   */
  setCurrentSettings(
    type,
    horseId,
    userId,
    multimediaPage,
    noteOrTaskId,
    refreshUploadQueue
  ) {
    this.type = type;
    this.horseId = horseId;
    this.userId = userId;
    this.multimediaPage = multimediaPage;
    this.noteOrTaskId = noteOrTaskId;
    this.dropbox = new window.Dropbox.Dropbox({
      accessToken: MultimediaHelper.DropboxToken,
    });
    this.refreshUploadQueue = refreshUploadQueue;
    // queue elements to be uploaded
  }
  setRefreshCallback(callback) {
    this.refreshUploadQueue = callback;
  }

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  shareItems(items) {
    this.urisToShare = [];

    for (let item_index in items) {
      const item = items[item_index];
      this.dropbox
        .filesDownload({
          path: item.path_display,
        })
        .then(async (response) => {
          let file_blob = response.fileBlob;

          const file = await Filesystem.writeFile({
            data: await this.blobToBase64(file_blob),
            directory: Directory.Cache,
            path: item.name,
          });

          this.urisToShare.push(file.uri);

          if (this.urisToShare.length == items.length) {
            Share.share({ files: this.urisToShare });
          }
        });
    }
  }

  /**
   * Setter for the callback function
   * @param {Function<>()} finishCallback The new finish callback function
   */
  setFinishCallback(finishCallback) {
    this.finishCallback = finishCallback;
  }

  /**
   * Setter for the progress callback function
   * @param {Function<>()} progressCallback The new progress callback function
   */
  setProgressCallback(progressCallback) {
    this.progressCallback = progressCallback;
  }

  /**
   * A function that adds files to the upload queue.
   *
   * @param {string} request_origin The location.href from which the files were added.
   * @param {Array<object>} files  List of files to be added to the upload queue.
   */
  addToUploadQueue(request_origin, files) {
    this.uploadQueue.push(
      ...files.map((file) => {
        return { file, request_origin, path: this.path };
      })
    );
    if (this.isUploading) return;
    this.isUploading = true;
    this.startUploadQueueElements();
  }

  /**
   * A function that takes all the elements from the queue, uploads them and calls the respective callbacks.
   */
  startUploadQueueElements = async () => {
    if (this.uploadQueue.length <= 0) {
      this.isUploading = false;
      return;
    }

    let el = { ...this.uploadQueue[0] };
    if (el.file.media_path) {
      // const tStat = await Filesystem.stat({
      //   path: el.file.media_path,
      // });
      // if (!tStat) {
      //   alert("Something went wrong when reading file");
      //   return;
      // }
      // alert(tStat);
      // fetch chunks and send them one by one.
      // const contents = await Filesystem.readFile({
      //   path: el.file.media_path,
      // });
      // const data_blob = await fetch(
      //   "data:video/mp4;base64," + contents.data
      // ).then((r) => r.blob());
      // el.file.actual_image = new File([data_blob], el.file.fileName, {
      //   type: el.file.mimeType,
      // });
    }
    // return;
    this._uploadWthSingleRequest(
      el.file,
      (dbxItem) => {
        if (dbxItem == null) {
          this.finishCallback(el.file.fileName, null);
        } else {
          dbxItem.type = MultimediaHelper.getTypeItem(dbxItem);

          this.dropbox
            .filesGetThumbnail({
              path: dbxItem.path_display,
              size: "w480h320",
            })
            .then((response) => {
              let url = window.URL.createObjectURL(response.fileBlob);
              dbxItem.thumbUrl = url;

              this.uploadQueue.shift();
              this.finishCallback(el.request_origin, el.file.fileName, dbxItem);
              this.startUploadQueueElements();
            })
            .catch((error) => {
              dbxItem.thumbUrl = "";

              this.uploadQueue.shift();
              this.finishCallback(el.request_origin, el.file.fileName, dbxItem);
              this.startUploadQueueElements();
            });
        }
      },
      el.request_origin,
      el.path
    );
    // }
  };

  /**
   * A function that returns all the elements in the upload queue such that the origin or the items matches the origin of the requester.
   * @param {string} request_origin The location.href of the page that requested the upload list.
   *
   * @returns a list of items from upload list that match the requester's origin.
   */
  loadUploadQueue = (request_origin) => {
    return this.uploadQueue.filter((item) =>
      item.request_origin.startsWith(request_origin)
    );
  };

  loadList = (request_origin, callback, type) => {
    this.loadCallback = callback;

    switch (type) {
      case `MultimediaHelper`.FOLDER_MULTIMEDIA:
        this.path = `/${MultimediaHelper.FOLDER_MULTIMEDIA}/${this.userId}/${this.horseId}`;
        break;
      case MultimediaHelper.FOLDER_EXTRA_NOTES:
        this.path = `/${this.type}/${this.horseId}/${this.noteOrTaskId}`;
        break;
      case MultimediaHelper.FOLDER_TASK:
        let horse = window.DataStorage.getAllHorses().find(
          (h) => h.id == this.horseId
        );
        this.path = `/${this.type}/${horse.userid}/${this.noteOrTaskId}`;
        break;
      case MultimediaHelper.FOLDER_GENERAL_TASK:
        this.path = `/${this.type}/${this.noteOrTaskId}`;
        break;
      default:
        this.path = `/${this.type}/${this.horseId}`;
        break;
    }

    this.dropbox
      .filesCreateFolder({
        path: this.path,
        autorename: false,
      })
      .then((response) => {
        if (this.type == MultimediaHelper.FOLDER_MULTIMEDIA) {
          this._getListFilesForMultimedia();
        } else if (
          this.type == MultimediaHelper.FOLDER_TASK &&
          this.multimediaPage
        ) {
          this._getListFilesForTasks();
        } else if (
          this.type == MultimediaHelper.FOLDER_NOTES &&
          this.multimediaPage
        ) {
          this._getListFilesForNotes();
        } else {
          this._getListFiles();
        }
      })
      .catch((error) => {
        if (this.type == MultimediaHelper.FOLDER_MULTIMEDIA) {
          this._getListFilesForMultimedia();
        } else if (
          this.type == MultimediaHelper.FOLDER_TASK &&
          this.multimediaPage
        ) {
          this._getListFilesForTasks();
        } else if (
          this.type == MultimediaHelper.FOLDER_NOTES &&
          this.multimediaPage
        ) {
          this._getListFilesForNotes();
        } else {
          this._getListFiles();
        }
      });
  };

  _getListFiles = () => {
    this.dropbox
      .filesListFolder({ path: this.path })
      .then((response) => {
        if (!response.entries) return;
        let items = [];
        for (let i = 0; i < response.entries.length; i++) {
          let item = response.entries[i];
          item.type = MultimediaHelper.getTypeItem(item);
          items.push(item);
        }
        items = items.sort(function (a, b) {
          if (a["server_modified"] > b["server_modified"]) return -1;
          if (a["server_modified"] < b["server_modified"]) return 1;
          return 0;
        });

        if (items.length != 0) {
          this._buildThumbs(items);
        } else {
          this.loadCallback(items);
        }
      })

      .catch((error) => {
        this.loadCallback(null);
      });
  };

  _getListFilesForMultimedia = () => {
    this.dropbox
      .filesListFolder({ path: this.path })
      .then((response) => {
        window.DataGate.getYoutubeMultimedia(
          this.userId,
          this.horseId,
          (code, youtubeData) => {
            if (!response.entries) return;
            let items = [];
            for (let i = 0; i < response.entries.length; i++) {
              let item = response.entries[i];
              item.type = MultimediaHelper.getTypeItem(item);
              //let ext = item.path_display.split('.').pop().toLowerCase();
              //if (ext == "png" || ext == "jpeg" || ext == "jpg" || ext == "gif" || ext == "bmp") {
              //    item.type = MultimediaHelper.TYPE_IMAGE;
              //} else {
              //    item.type = MultimediaHelper.TYPE_VIDEO;
              //}
              items.push(item);
            }
            items = items.sort(function (a, b) {
              if (a["server_modified"] > b["server_modified"]) return -1;
              if (a["server_modified"] < b["server_modified"]) return 1;
              return 0;
            });
            if (youtubeData != null) {
              for (let i = 0; i < youtubeData.length; i++) {
                let item = youtubeData[i];
                item.type = MultimediaHelper.TYPE_YOUTUBE;
                items.push(item);
              }
            }

            if (items.length != 0) {
              this._buildThumbs(items);
            } else {
              this.loadCallback(items);
            }
          }
        );
      })
      .catch((error) => {
        this.loadCallback(null);
      });
  };

  _getListFilesForTasks = () => {
    let end = new Date().formatDesh();
    let start = new Date().addDays(-92).formatDesh();
    window.db.getTasksByHorseIdForMultimedia(
      this.horseId,
      start,
      end,
      (taskArr) => {
        let horse = window.DataStorage.getAllHorses().find(
          (h) => h.id == this.horseId
        );
        let horseOwnerId = horse.userid;
        let items = [];
        if (!taskArr.length) this.loadCallback(items);
        for (let i = 0; i < taskArr.length; i++) {
          this.path = "/Task/" + horseOwnerId + "/" + taskArr[i]["Id"];
          this.dropbox
            .filesListFolder({ path: this.path })
            .then((response) => {
              if (!response.entries) return;

              for (let i = 0; i < response.entries.length; i++) {
                let item = response.entries[i];
                item.type = MultimediaHelper.getTypeItem(item);
                //let ext = item.path_display.split('.').pop().toLowerCase();
                //if (ext == "png" || ext == "jpeg" || ext == "jpg" || ext == "gif" || ext == "bmp") {
                //    item.type = MultimediaHelper.TYPE_IMAGE;
                //} else {
                //    item.type = MultimediaHelper.TYPE_VIDEO;
                //}
                items.push(item);
              }
              items = items.sort(function (a, b) {
                if (a["server_modified"] > b["server_modified"]) return -1;
                if (a["server_modified"] < b["server_modified"]) return 1;
                return 0;
              });

              if (i == taskArr.length - 1) {
                setTimeout(() => {
                  if (items.length != 0) {
                    this._buildThumbs(items);
                  } else {
                    this.loadCallback(items);
                  }
                }, 500);
              }
            })
            .catch((error) => {
              this.loadCallback(null);
            });
        }
      }
    );
  };

  _getListFilesForNotes = () => {
    window.db.getNotesByHorse(this.horseId, (notesArr) => {
      let items = [];
      this.dropbox
        .filesListFolder({ path: this.path })
        .then((response) => {
          if (!response.entries) return;
          for (let i = 0; i < response.entries.length; i++) {
            let item = response.entries[i];
            item.type = MultimediaHelper.getTypeItem(item);
            //let ext = item.path_display.split('.').pop().toLowerCase();
            //if (ext == "png" || ext == "jpeg" || ext == "jpg" || ext == "gif" || ext == "bmp") {
            //    item.type = MultimediaHelper.TYPE_IMAGE;
            //} else {
            //    item.type = MultimediaHelper.TYPE_VIDEO;
            //}
            items.push(item);
          }
          items = items.sort(function (a, b) {
            if (a["server_modified"] > b["server_modified"]) return -1;
            if (a["server_modified"] < b["server_modified"]) return 1;
            return 0;
          });
          if (!notesArr.length) this.loadCallback(items);
          for (let i = 0; i < notesArr.length; i++) {
            this.path =
              `/${MultimediaHelper.FOLDER_EXTRA_NOTES}/` +
              this.horseId +
              "/" +
              notesArr[i]["Id"];
            this.dropbox
              .filesListFolder({ path: this.path })
              .then((response) => {
                if (!response.entries) return;

                for (let i = 0; i < response.entries.length; i++) {
                  let item = response.entries[i];
                  item.type = MultimediaHelper.getTypeItem(item);
                  //let ext = item.path_display.split('.').pop().toLowerCase();
                  //if (ext == "png" || ext == "jpeg" || ext == "jpg" || ext == "gif" || ext == "bmp") {
                  //    item.type = MultimediaHelper.TYPE_IMAGE;
                  //} else {
                  //    item.type = MultimediaHelper.TYPE_VIDEO;
                  //}
                  items.push(item);
                }
                items = items.sort(function (a, b) {
                  if (a["server_modified"] > b["server_modified"]) return -1;
                  if (a["server_modified"] < b["server_modified"]) return 1;
                  return 0;
                });

                if (i == notesArr.length - 1) {
                  setTimeout(() => {
                    if (items.length != 0) {
                      this._buildThumbs(items);
                    } else {
                      this.loadCallback(items);
                    }
                  }, 500);
                }
              })
              .catch((error) => {
                this.loadCallback(null);
              });
          }
        })
        .catch((error) => {
          this.loadCallback(null);
        });
    });
  };

  _checkAllThumbLoaded = () => {
    let notLoadedItems = this.items.filter((item) => item.thumbUrl == null);
    if (notLoadedItems.length == 0) {
      this.loadCallback(this.items);
    }
  };

  _buildThumbs = (items) => {
    this.items = items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type == MultimediaHelper.TYPE_YOUTUBE) {
        let code = this._getYoutubeCode(items[i].Link);
        items[i].thumbUrl = `https://img.youtube.com/vi/${code}/hqdefault.jpg`;
        items[i].fullUrl = `https://www.youtube.com/embed/${code}`;
      } else {
        this._loadThumb(items[i]);
      }
    }
    this._checkAllThumbLoaded();
  };

  _getYoutubeCode = (link) => {
    //https://youtu.be/tezlfdvAzcc
    //https://www.youtube.com/watch?v=M_hVFRTzFw8

    if (link.indexOf("youtu.be") != -1) {
      let code = link.split("/").pop();
      return code;
    }
    if (link.indexOf("?v=") != -1) {
      let code = link.split("?v=").pop();
      return code;
    }
    return null;
  };

  _loadThumb = (item) => {
    new Promise((resolve, reject) => {
      this.dropbox
        .filesGetThumbnail({
          path: item.path_display,
          size: "w480h320",
        })
        .then((response) => {
          let url = window.URL.createObjectURL(response.fileBlob);
          item.thumbUrl = url;
          this._checkAllThumbLoaded();
        })
        .catch((error) => {
          item.thumbUrl = "";
          this._checkAllThumbLoaded();
        });
    });
  };

  getItemLink = (item, callback) => {
    if (item.fullUrl != null) {
      if (callback) callback(item.fullUrl);
      return;
    }
    if (item.type == MultimediaHelper.TYPE_YOUTUBE) {
      let code = this._getYoutubeCode(item);
      item.fullUrl = `https://www.youtube.com/embed/${code}`;
      if (callback) callback(item.fullUrl);
      return;
    }

    this.dropbox
      .filesGetTemporaryLink({ path: item.path_display })
      .then((response) => {
        item.fullUrl = response.link;
        if (callback) callback(item.fullUrl);
      })
      .catch(function (error) {
        if (callback) callback(null);
      });
  };

  _loadThubmAndUploadCallback = (
    fileName,
    dbxItem,
    callback,
    request_origin
  ) => {
    if (dbxItem == null) {
      callback(fileName, null);
    } else {
      dbxItem.type = MultimediaHelper.getTypeItem(dbxItem);
      //let ext = dbxItem.path_display.split('.').pop().toLowerCase();
      //if (ext == "png" || ext == "jpeg" || ext == "jpg" || ext == "gif" || ext == "bmp") {
      //    dbxItem.type = MultimediaHelper.TYPE_IMAGE;
      //} else {
      //    dbxItem.type = MultimediaHelper.TYPE_VIDEO;
      //}
      this.dropbox
        .filesGetThumbnail({
          path: dbxItem.path_display,
          size: "w480h320",
        })
        .then((response) => {
          let url = window.URL.createObjectURL(response.fileBlob);
          dbxItem.thumbUrl = url;

          callback(fileName, dbxItem, request_origin);
        })
        .catch((error) => {
          dbxItem.thumbUrl = "";
          callback(fileName, dbxItem, request_origin);
        });
    }
  };
  wait(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  _setSoothProgress = async (file, new_progress, request_origin) => {
    const duration = 2000;
    const steps_per_seconds = 2;
    const steps = (duration / 1000) * steps_per_seconds;
    const delay_between_steps = 1 / steps_per_seconds;
    for (let i = 0; i <= steps; i++) {
      // alert(file.progress + ((new_progress - file.progress) * i) / steps);
      // this.progressCallback(
      //   request_origin,
      //   file.name,
      //   file.progress + ((file.progress - new_progress) * i) / steps
      // );
    }
  };

  _uploadWthSingleRequest = async (
    file,
    doneCallback,
    request_origin,
    file_path
  ) => {
    const path = file_path + "/" + file.fileName;
    const maxBlob = 8 * 1024 * 1024; // 8MB  chunk size
    if (!file.actual_image) {
      if (file.fileSize > maxBlob) {
        this.uploadFileWithProgress(
          file,
          path,
          doneCallback,
          request_origin,
          this.dropbox
        );
        return;
      }
    }

    this.progressCallback(request_origin, file.name, 0);

    FileChunkReader.addListener("uploadComplete", (info) => {
      FileChunkReader.removeAllListeners("uploadComplete");

      if (!info || !info.success) {
        doneCallback(null, request_origin);
        return;
      }

      doneCallback(JSON.parse(info.response), request_origin);
    });

    FileChunkReader.uploadFile({
      uri: file.media_path,
      accessToken:
        "HqmkA9nKm0wAAAAAAADLWpj-stRJN_4JyfLxtRoZD-Rzpjyz9nnuI_CMbkRkOoSk",
      targetPath: path,
    }).then();
  };
  base64ToBlob(base64, mimeType = "") {
    // Decode Base64 string to a binary string
    const binaryStr = atob(base64);
    // Create a Uint8Array of the same length as the binary string
    const length = binaryStr.length;
    const bytes = new Uint8Array(length);
    // Fill the Uint8Array with byte values from the binary string
    for (let i = 0; i < length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    // Create and return a Blob from the Uint8Array
    return new Blob([bytes], { type: mimeType });
  }
  uploadFileWithProgress = async (
    file,
    path,
    doneCallback,
    request_origin,
    dbx
  ) => {
    const fileSize = file.fileSize;

    try {
      FileChunkReader.addListener("uploadProgress", (info) => {
        this.progressCallback(request_origin, file.fileName, info.progress);
      });

      FileChunkReader.addListener("uploadComplete", (info) => {
        FileChunkReader.removeAllListeners("uploadProgress");
        FileChunkReader.removeAllListeners("uploadComplete");
        if (info.success) {
          doneCallback(JSON.parse(info.response), request_origin);
        } else {
          console.error("Upload failed");
        }
      });

      FileChunkReader.uploadFileChunk({
        uri: file.media_path,
        fileSize: fileSize,
        accessToken:
          "HqmkA9nKm0wAAAAAAADLWpj-stRJN_4JyfLxtRoZD-Rzpjyz9nnuI_CMbkRkOoSk",
        targetPath: path,
      }).then();
    } catch (error) {
      console.error(error);
      doneCallback(null, request_origin);
    }
  };

  cancelUploading = (fileName) => {
    let cancelIndex = this.uploadQueue.findIndex(
      (f) => f.file.fileName == fileName
    );
    this.uploadQueue.splice(cancelIndex, 1);

    this.refreshUploadQueue();
  };

  uploadYoutube = (link, callback) => {
    window.DataGate.addYoutubeMultimedia(
      link,
      this.userId,
      this.horseId,
      (c, data) => {
        let code = this._getYoutubeCode(link);
        const item = {
          Link: link,
          type: MultimediaHelper.TYPE_YOUTUBE,
          fullUrl: `https://www.youtube.com/embed/${code}`,
          thumbUrl: `https://img.youtube.com/vi/${code}/hqdefault.jpg`,
        };
        callback(item);
      }
    );
  };

  deleteItems = (items, callback) => {
    this.deleteCallback = callback;
    this.itemsForDelete = items;
    for (let i = 0; i < this.itemsForDelete.length; i++) {
      this._deleteItem(this.itemsForDelete[i]);
    }
  };

  _deleteItem = (item) => {
    if (item.type == MultimediaHelper.TYPE_YOUTUBE) {
      window.DataGate.deleteYoutubeMultimedia(item.Id, () => {
        item.isDeleted = true;
        this._checkItemsDelete();
      });
    } else {
      this.dropbox
        .filesDelete({ path: item.path_display })
        .then((response) => {
          item.isDeleted = true;
          this._checkItemsDelete();
        })
        .catch((error) => {
          console.error(error);
          item.isDeleted = true;
          this._checkItemsDelete();
        });
    }
  };

  _checkItemsDelete = () => {
    let notDeletedItems = this.itemsForDelete.filter((item) => !item.isDeleted);
    if (notDeletedItems.length == 0) {
      this.deleteCallback();
    }
  };

  changeName = (item, nameNew, callback) => {
    const pathNew =
      item.path_display.substring(0, item.path_display.lastIndexOf("/")) +
      "/" +
      nameNew;
    this.dropbox
      .filesMove({
        from_path: item.path_display,
        to_path: pathNew,
      })
      .then((response) => {
        response.thumbUrl = item.thumbUrl;
        response.type = item.type;
        if (callback) callback(response);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  downloadItems = (items, callback) => {
    let dowloadStep = (itemIndex) => {
      if (itemIndex < items.length) {
        this._downloadItem(items[itemIndex], () => {
          dowloadStep(itemIndex + 1);
        });
      } else {
        window.Spinner.hide();
        //end
      }
    };

    window.Spinner.show();
    dowloadStep(0);
  };

  /**
   *
   * Download a list of items from dropbox
   *
   * @param {String[]} items list of items to be downloaded
   *
   * @returns A list of blobs, corresponding to the items provided.
   */
  downloadAllItems = async (items) => {
    let result = [];
    for (let item of items) {
      if (item.type == MultimediaHelper.TYPE_YOUTUBE) {
        continue;
      }
      const response = await this.dropbox.filesDownload({
        path: item.path_display,
      });
      result.push(
        new File([response.fileBlob], response.name, {
          type: "image/jpeg",
        })
      );
    }
    return result;
  };

  _downloadItem = (item, callback) => {
    if (item.type == MultimediaHelper.TYPE_YOUTUBE) {
      callback();
      return;
    }

    this.dropbox
      .filesDownload({
        path: item.path_display,
      })
      .then((response) => {
        var downloadUrl = URL.createObjectURL(response.fileBlob);
        var downloadButton = document.createElement("a");
        downloadButton.setAttribute("href", downloadUrl);
        downloadButton.setAttribute("download", response.name);
        downloadButton.setAttribute("class", "button");
        downloadButton.innerText = "Download: " + response.name;
        downloadButton.click();

        callback();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  showMobileFullscreen(imageItem) {
    if (
      window.multimediaMobileHelper.isActive &&
      this.type == MultimediaHelper.FOLDER_MULTIMEDIA
    ) {
      window.multimediaMobileHelper.showFullScreen(
        this.userId,
        this.horseId,
        imageItem
      );
      return true;
    }
    return false;
  }

  downloadAndShareItems(items) {
    if (window.multimediaMobileHelper.isActive) {
      window.multimediaMobileHelper.downloadAndShareItems(items);
    }
  }

  hasImages = (callback) => {
    this.path = `/${MultimediaHelper.FOLDER_MULTIMEDIA}/${this.userId}/${this.horseId}`;
    this.dropbox
      .filesListFolder({ path: this.path })
      .then((response) => {
        if (callback) callback(response.entries.length > 0);
      })
      .catch((error) => {
        if (callback) callback(false);
      });
  };

  static getTypeItem(item) {
    let ext = item.path_display.split(".").pop().toLowerCase();
    if (
      ext == "png" ||
      ext == "jpeg" ||
      ext == "jpg" ||
      ext == "gif" ||
      ext == "bmp"
    ) {
      return MultimediaHelper.TYPE_IMAGE;
    } else if (ext == "pdf") {
      return MultimediaHelper.TYPE_PDF;
    } else {
      return MultimediaHelper.TYPE_VIDEO;
    }
  }
}
